import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'Des étapes doivent être complétées'.
 */
export class CompletedStepsConditionData extends BaseConditionData {
    /**
     * Ids des étapes devant être complétées.
     */
    public steps: number[] = [];

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.StepCompleted);
    }

    /**
     * Retourne une copie d'une instance de CompletedStepsConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: CompletedStepsConditionData) {
        if (!!other) {
            const instance = new CompletedStepsConditionData();
            instance.steps = other.steps;
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
